<template>
	<div
		class="sticky-cart insicht insicht--fade-in"
		@click.prevent="onClick"
	>
		<div
			class="sticky-cart__summary"
			v-if="hasBasket"
		>
			<div
				class="sticky-cart__summary-icon cart-icon"
			>
				<SVGCart class="sticky-cart__summary-icon-icon"/>
				<span
					class="sticky-cart__summary-icon-count"
					v-if="totalItemsWithoutAdditional"
					v-html="totalItemsWithoutAdditional"
				/>
			</div>

			<div class="sticky-cart__summary-details">
				<span
					class="sticky-cart__summary-total"
					v-html="$options.filters.madpricecent(total)"
				/>
				<!-- <span
					class="sticky-cart__summary-shipping"
					v-if="deliveryPrice"
					v-html="$t('cart.deliveryFeePrice', { price: $options.filters.madpricecent(deliveryPrice, 'short') })"
				/> -->
				<span
					class="sticky-cart__summary-shipping-min"
					v-if="deliveryPrice && minCartFreePrice"
					v-html="$t('cart.freeDeliveryStandalone', { price: $options.filters.madpricecent(minCartFreePrice) })"
				/>
			</div>
		</div>

		<Button
			class="sticky-cart__button"
			type="button"
			level="primary"
			:text="hasBasket ? $t('cart.stickyCartButton') : $t('cart.stickyCartStartOrder')"
		/>
	</div>
</template>

<script>
import Button from '@/components/Button';

import { mapGetters } from "vuex"
import htmlComponent from 'htmlcomponent'

export default {
	components: {
		Button,
	},
	props: {

	},
	data() {
		return {
		};
	},
	computed: {
		...mapGetters("cart", [
			"deliveryPrice",
			"minCartFreePrice",
			"total",
			"totalItemsWithoutAdditional",
			"hasBasket",
		]),
	},
	methods: {
		onClick() {
			if (this.hasBasket) {
				htmlComponent.send('overlay:open', {type: 'sidebar-cart'});
			}
			else {
				this.$store.dispatch('redirect', { name: 'shop' })
			}
		},
	}
}
</script>

<style>
</style>
